import axios from "axios"

export const RATE_LIMIT_MESSAGE = "Too many requests, please try again in a minute";

export function isRateLimited(err) {
    return err?.response?.status === 429;
}

export function getTemplateData() {
    const url = new URLSearchParams(window.location.search);
    const token = url.get("token");

    return axios.get(`${process.env.REACT_APP_URL}/v4/customer/redemption/template?token=${token}`)
}

// couponItems is needed on most pages; fetch once per token and share the response.
const couponItemsCache = new Map();

export function getCouponItems(token) {
    if (!couponItemsCache.has(token)) {
        const request = axios
            .get(`${process.env.REACT_APP_URL}/v4/customer/redemption/couponItems?token=${token}`)
            .catch((err) => {
                couponItemsCache.delete(token);
                throw err;
            });
        couponItemsCache.set(token, request);
    }
    return couponItemsCache.get(token);
}

export function clearCouponItemsCache(token) {
    couponItemsCache.delete(token);
}
